import {getIOUrl} from "Core/io/helper";
import {getArray, getBool} from 'Core/helpers/data';
import {setStorageValue, STORAGE_TYPE} from "Core/storage";
import {addErrorMessage} from "Core/helpers/message";
import {messages_default_auto_hide_after} from "Config/app";
import {ioJsonRequest} from "Core/io";
import * as languageDataMap from './dataMap';

/**
 * Fetch the list of all languages (active and inactive) that API supports from IO
 * @return {Promise<LanguageDataObject[]>}
 */
export const fetchAllSupportedLanguages = () => {
	const api = 'defaultApi';
	const endpoint = 'language/fetch-all-active';
	const url = getIOUrl(api, endpoint);

	return ioJsonRequest({url, api, endpoint, autoToken: false, data: null})
		// Map response data
		.then(res => getArray(res, 'data').map(i => languageDataMap.input(i)))
		// Load languages into Redux storage
		.then(languages => {
			/** @type {LanguageDataObject[]} */
			setStorageValue('supported_languages', languages, STORAGE_TYPE.REDUX);
			return languages;
		})
		.catch(error => {
			// Render error if it is not 'AbortError' or 'hidden' flag is not true
			// @note: Error should be an object with 'message' field already translated and ready for display.
			if (error.name !== 'AbortError' && !getBool(error, 'hidden')) {
				addErrorMessage(error.message, messages_default_auto_hide_after);
			}
			return null;
		});
};